"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NetforumErrorType;
(function (NetforumErrorType) {
    NetforumErrorType["DUPLICATE"] = "Individual already exists.";
})(NetforumErrorType = exports.NetforumErrorType || (exports.NetforumErrorType = {}));
//# sourceMappingURL=index.js.map